import CreditNoteCreateContainer from "@legacy/credit_notes/CreditNoteCreateContainer"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { NavTopBar } from "@organisms"

import { AppFrame } from "@templates"

import { CREDIT_NOTES_ROUTES } from "@routes/creditNotes"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function CreditNoteCreate() {
    const [listRoute] = useSlugExtractor([CREDIT_NOTES_ROUTES.LIST])
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const backDestination = hasPermission("invoices_list_permission", PERMISSION_LEVEL.FULL) ? listRoute : undefined

    return (
        <AppFrame.Root navigationType="inner">
            <NavTopBar.Root>
                <NavTopBar.Header>
                    <NavTopBar.NavTopBarHeaderStart>
                        <NavTopBar.PageInnerTitle label="New Credit Note" backDestination={backDestination} />
                    </NavTopBar.NavTopBarHeaderStart>
                </NavTopBar.Header>
            </NavTopBar.Root>
            <AppFrame.PageContent>
                <CreditNoteCreateContainer formMode="ADD_CREDIT_NOTE" addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
